import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import img from "../../img/img.png";

import { Autoplay, Pagination, Navigation } from "swiper";

const Testimonials = () => {
  return (
    <div className="my-16" id="testimonials">
      <h2 className="text-center text-3xl uppercase my-12 underline decoration-solid">
        {" "}
        Testimonials{" "}
      </h2>
      <>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          centeredSlides={false}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="card   shadow-xl">
              <div className="flex justify-center items-center">
                <div class="avatar flex items-center justify-center mr-4">
                  <div class="w-20 my-2 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                    <img src={img} alt="person"></img>
                  </div>
                </div>
                <div>
                  <h2 className="font-bold">Tanvir Ahmad</h2>
                  <h3 className="font-bold">
                    Junior Web Developer, <br />
                    Seeking Job
                  </h3>
                </div>
              </div>
              <div className=" rating flex justify-center rating-sm">
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mr-1 mask mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
                <input
                  type="radio"
                  name="rating-5"
                  class="bg-primary mask mr-1 mask-star-2 "
                />
              </div>

              <div class="card-body">
                <i className="fa fa-quote-left text-primary" />
                This guy is incredibly awesome, I hired him and when He
                delivered, I honestly fell in love with the project. He is
                indeed a great guy
                <i className="fa fa-quote-right text-primary" />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </>
    </div>
  );
};

export default Testimonials;
